import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

const initialState = {
  likes: 0,
  isSaved: false,
};
export const fetchLikeAndSaved = createAsyncThunk(
  "likeAndSaved/fetchLikeAndSaved",
  async (id) => {
    const likeAndSaved = await axiosInstance.get(`/blogs/${id}`);
    return likeAndSaved.data;
  }
);
export const updateLikes = createAsyncThunk(
  "likeAndSaved/updateLikes",
  async ({ blogId, likes }) => {
    const updatedLikes = await axiosInstance.patch(`/blogs/${blogId}`, {
      likes: likes + 1,
    });
    return updatedLikes.data;
  }
);
export const updateSaved = createAsyncThunk(
  "likeAndSaved/updateSaved",
  async ({ blogId, isSaved }) => {
    const updatedSaved = await axiosInstance.patch(`/blogs/${blogId}`, {
      isSaved: !isSaved,
    });
    return updatedSaved.data;
  }
);

const likeAndSavedSlice = createSlice({
  name: "likeAndSaved",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchLikeAndSaved.fulfilled, (state, action) => {
        state.likes = action.payload.likes;
        state.isSaved = action.payload.isSaved;
      })
      .addCase(updateLikes.fulfilled, (state, action) => {
        state.likes = action.payload.likes;
      })
      .addCase(updateSaved.fulfilled, (state, action) => {
        state.isSaved = action.payload.isSaved;
      });
  },
});

export default likeAndSavedSlice.reducer;
